// @ts-ignore
/* eslint-disable */
import request from '../request';

/** List logs by traceId. GET /api/logs/${param0} */
export async function listLogsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.listLogsUsingGETParams,
  options?: { [key: string]: any },
) {
  const { traceId: param0, ...queryParams } = params;
  return request<API.ItemResponseListUniverseLog_>(`/api/logs/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}
